const getAppConfiguration = () => {
	return {
		...window.appConfigurations,
		locale: window.LocalizationConfig.locale,
		themeSettings: {
			...window.themeSettings,
			...window.themeSettings.themeSettings,
		},
	};
};

export const SERVICE_CATEGORIES = {
	ACTIVITIES: 'activities',
	RESTAURANTS: 'restaurants',
	RENTALS: 'rentals',
	ATTRACTIONS: 'attractions',
	HOTELS: 'hotels',
	['App\\Tour']: 'activities',
	['App\\Rental']: 'rentals',
	['App\\Activity']: 'attractions',
	['App\\Restaurant']: 'restaurants',
};

export const HOTEL_STATUS = {
	PROCESSING: 'Processing',
	APPROVED: 'Approved',
	HIDE: 'Hide',
};

export const USER_ROLE_IDS = {
	GENERAL: 1,
	SUPPLIER: 2,
	PARTNER: 3,
	ADMIN: 4,
	GUEST: 5,
};

export const SERVICEABLE_TYPE = {
	ACTIVITIES: 'App\\Tour',
	RENTAL: 'App\\Rental',
	ATTRACTIONS: 'App\\Activity',
	HOTELS: 'hotels',
	RESTAURANTS: 'App\\Restaurant',
};

export const CUSTOMIZE_SITE_TYPE = {
	INFLUENCER: 'Influencer',
	SELF: 'Self',
};

export const ALGOLIA_RESULT_TYPES = {
	LOCATION: 'location',
};

export const CHANNEL_MANAGER_ID = {
	SELF_HOTEL: 1,
	THON_HOTEL: 2,
	RATE_TIGER: 3,
	ZAUI_STAY: 4,
	I_CAL: 5,
	VISIT_GALAXY: 6,
};

export default getAppConfiguration;
